import React, { useState } from 'react';

import { useMediaQuery } from 'react-responsive';

import { ProducerSearchMobile, ProducerSearchDesktop } from '/components/producer-search/components';

const ProducerSearch = () => {
    const isMobile = useMediaQuery({ query: '(max-width: 767px)' });
    const isDesktop = useMediaQuery({ query: '(min-width: 768px)' });

    const [activeHit, setActiveHit] = useState(null);

    window.activeHit = activeHit;
    window.setActiveHit = (hit) => {
        setActiveHit(hit);
    };

    return (
        <React.Fragment>
            {isMobile && <ProducerSearchMobile activeHit={activeHit} />}
            {isDesktop && <ProducerSearchDesktop activeHit={activeHit} />}
        </React.Fragment>
    );
};

export { ProducerSearch };
